var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9625 23.5254C11.725 23.5254 11.4875 23.4379 11.3 23.2504L3.71255 15.6629C3.35005 15.3004 3.35005 14.7004 3.71255 14.3379L11.3 6.75039C11.6625 6.38789 12.2625 6.38789 12.625 6.75039C12.9875 7.11289 12.9875 7.71289 12.625 8.07539L5.70005 15.0004L12.625 21.9254C12.9875 22.2879 12.9875 22.8879 12.625 23.2504C12.45 23.4379 12.2 23.5254 11.9625 23.5254Z",
    fill: "#484EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6249 15.9375H4.5874C4.0749 15.9375 3.6499 15.5125 3.6499 15C3.6499 14.4875 4.0749 14.0625 4.5874 14.0625H25.6249C26.1374 14.0625 26.5624 14.4875 26.5624 15C26.5624 15.5125 26.1374 15.9375 25.6249 15.9375Z",
    fill: "#484EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowLeft);
export default __webpack_public_path__ + "static/media/slider-arrow-left.d3ec9e0294b614c32fb24046a5e534c2.svg";
export { ForwardRef as ReactComponent };